import { useState } from 'react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { History } from 'lucide-react';

export const RenewalHistoryDialog = ({ vehicle, el }) => {
    const [open, setOpen] = useState(false);
    const renewals = [...(vehicle.renewals || [])].reverse();
    const loc = el ? 'el-GR' : 'en-GB';
    const d = (v) => (v ? new Date(v).toLocaleDateString(loc) : '-');
    const km = (v) => (v ? `${v.toLocaleString(loc)} km` : '-');

    return (
        <>
            <Button variant="ghost" size="sm" onClick={() => setOpen(true)} className="text-slate-500 relative" title={el ? 'Ιστορικό ανανεώσεων' : 'Renewal history'} data-testid={`leasing-vehicle-history-${vehicle.id}`}>
                <History className="w-4 h-4" />
                {renewals.length > 0 && <span className="absolute -top-1 -right-1 text-[10px] bg-[#1B7EB5] text-white rounded-full w-4 h-4 flex items-center justify-center">{renewals.length}</span>}
            </Button>
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent className="bg-white max-w-xl" data-testid="renewal-history-dialog">
                    <DialogHeader>
                        <DialogTitle>{el ? 'Ιστορικό ανανεώσεων' : 'Renewal history'} - {vehicle.license_plate}</DialogTitle>
                    </DialogHeader>
                    {renewals.length ? (
                        <table className="w-full text-sm">
                            <thead>
                                <tr className="text-left text-xs text-slate-500">
                                    <th className="pb-2">{el ? 'Ημερομηνία' : 'Date'}</th>
                                    <th className="pb-2">{el ? 'Λήξη (παλιά → νέα)' : 'End (old → new)'}</th>
                                    <th className="pb-2">{el ? 'Όριο km (παλιό → νέο)' : 'Km limit (old → new)'}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {renewals.map((r, i) => (
                                    <tr key={i} className="border-t border-slate-100" data-testid={`renewal-row-${i}`}>
                                        <td className="py-2 text-slate-600">{d(r.at)}</td>
                                        <td className="py-2 text-slate-800">{d(r.previous_end)} → <b>{d(r.contract_end_date)}</b></td>
                                        <td className="py-2 text-slate-800">{km(r.previous_km_limit)} → <b>{km(r.km_limit)}</b></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <p className="text-sm text-slate-500" data-testid="renewal-history-empty">{el ? 'Δεν έχουν γίνει ανανεώσεις.' : 'No renewals yet.'}</p>
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
};
